import { HttpHandler } from '../HttpHandler';
import { environment } from '../../enviroments';
import { UnReadeMessages } from '../../pages/types';

export const getChatRoomsList = async (clientID: string, limit: number, offset: number) => {
  const roomsData = await HttpHandler({
    method: 'GET',
    url: `${environment.AGORA_URL}/client-chat-rooms/${clientID}?limit=${limit}&offset=${offset}&orderBy=updated_at.desc`,
  });

  return roomsData;
};

export const getChatRoomsListBySpecialistId = async (clientID: string, specialistID: string) => {
  const roomsData = await HttpHandler({
    method: 'GET',
    url: `${environment.AGORA_URL}/client-chat-rooms/${clientID}?specialist_id=equal:${specialistID}`,
  });

  return roomsData;
};

export const getUnReadMessages = async (clientID: string) => {
  const roomsData = await HttpHandler({
    method: 'GET',
    url: `${environment.AGORA_URL}/unread-client-messages/${clientID}`,
  });

  return roomsData.data as UnReadeMessages[];
};

export const getBroadcastChatRoom = async (clientId: string) => {
  const roomsData = await HttpHandler({
    method: 'GET',
    url: `${environment.CHAT_APP_API_URL}/chat-rooms/client/${clientId}/broadcast-room`,
  });

  return roomsData;
};
